import {HttpBackend, HttpClient} from '@angular/common/http';
import {Inject, Injectable } from '@angular/core';
import { APP_CONFIG, AppConfig } from '@src/app.config';
import { RequestService } from '@src/app/shared/services/http/request/request.service';
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {
  ConfirmPhoneCodeDto,
  RequestPhoneCodeDto,
  SetupPasswordDto,
} from '@app/areas/auth/models/auth-onboarding.dto';
import {LocalizeService} from '@shared/services/helpers/localize/localize.service';

@Injectable({
  providedIn: 'root'
})
export class AuthApiService {
  private httpNoIntercept: HttpClient;
  private readonly authBase: string;

  constructor(
    @Inject(APP_CONFIG) private appConfig: AppConfig,
    private requestService: RequestService,
    private httpBackend: HttpBackend,
    private localizeService: LocalizeService,
  ) {
    this.httpNoIntercept = new HttpClient(this.httpBackend);
    this.authBase = `${this.appConfig.baseApiEndpoint}/app/auth`;
  }

  /**
   * This version bypasses your interceptors entirely.
   */
  checkAuth(token: string): Observable<{ active: boolean }> {
    const url = `${this.appConfig.baseApiEndpoint}/app/auth/introspect`;

    // if you need to pass the token in headers instead of via interceptor:
    const headers = {
      Authorization: `Bearer ${token}`,
      'x-locale': this.localizeService.currentLocaleValue?.trim() || 'en-AU',
    };

    return this.httpNoIntercept
      .get<any>(url, { headers, observe: 'response' })
      .pipe(map(resp => resp.body as { active: boolean }));
  }

  sendOtp(phoneNumber: string): Observable<RequestPhoneCodeDto> {
    const url = `${this.authBase}/requestPhoneCode`;
    return this.requestService.post(url, { phoneNumber }).pipe(map(r => r.body as RequestPhoneCodeDto));
  }

  verifyOtp(token: string, code: string): Observable<ConfirmPhoneCodeDto> {
    const url = `${this.authBase}/confirmPhoneCode`;
    return this.requestService.post(url, { token, code }).pipe(map(r => r.body as ConfirmPhoneCodeDto));
  }

  setupPassword(token: string, password: string): Observable<SetupPasswordDto> {
    const url = `${this.authBase}/setupPassword`;
    return this.requestService.post(url, { token, password }).pipe(map(r => r.body as SetupPasswordDto));
  }

  loginOtp(token: string): Observable<{ accessToken: string, expires: number }> {
    const url = `${this.authBase}/otpLogin`;
    return this.requestService.post(url, {token}).pipe(map(r => r.body))
  }
}
